import React, { Component } from "react";

import { Link } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import NativeSelect from '@material-ui/core/NativeSelect';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';

class ProjectForm extends Component {
	constructor(props) {
		super(props);
		
		this.state = {processing: false};

		this.handleMergePrject = this.handleMergePrject.bind(this);
		this.pintaPhases = this.pintaPhases.bind(this);
	}
	
	handleMergePrject(){
		this.setState({processing: true});
		this.props.mergePrject();
	}
	
	pintaPhases(){
		const rows = [];
		if(this.props.project.phase){
			this.props.project.phase.sort(function(a, b) {return a.sequence-b.sequence}).forEach(
											element => {
															rows.push(
																<TableRow key={element.id}>
																	<TableCell>{element.id}</TableCell>
																	<TableCell>{element.type}</TableCell>
																	<TableCell><a target="_blank" style={{textDecoration: 'none'}} href={process.env.REACT_APP_serverURL+"/documents-0.0.1/document/"+element.document.id+"/content?access_token="+this.props.accessToken} title={element.document.filename}>{element.document.filename}</a></TableCell>
																</TableRow>
															);
											}
										);
		}
		return <Table className="lst">
		    <TableHead>
		      <TableRow>
		        <TableCell>Id</TableCell>
				<TableCell>Type</TableCell>
				<TableCell>Document</TableCell>
		      </TableRow>
		    </TableHead>
		    <TableBody>{rows}</TableBody>
		    <TableFooter>
            </TableFooter>
			</Table>
	}
	
	render() {
		//console.log(this.props);
		
		if(this.state.processing){
			return (<div>PROCESSING...</div>);
		}
		
		let phases = this.pintaPhases();
		let lastPhase = this.props.project.phase.sort(function(a, b) {return a.sequence-b.sequence})[this.props.project.phase.length-1];
		let mltDescription = ""
		if(this.props.project.hasOwnProperty('mlt')){
			mltDescription = <div>Template: {this.props.project.mlt.name} [{this.props.project.mlt.tipo}]: {this.props.project.mlt.definition}</div>
		}
		
		const mergeBtn = (lastPhase.type=="FINISHED"?<Button onClick={this.handleMergePrject} size="small" variant="outlined" aria-label="Preprocesar">Merge project</Button>:"")
		
		return (
			<div className="contentM">
			<Grid container direction="column" alignItems="flex-start" justify="flex-start" spacing={2} xs={12}>
				<Grid item xs={12}>
					Name: {this.props.project.name}
				</Grid>
				<Grid item xs={12}>
					Code: {this.props.project.code}
				</Grid>
				<Grid item xs={12}>
					{mltDescription}
				</Grid>
			</Grid>

			<Grid container direction="row" alignItems="center" justify="flex-start" spacing={2} xs={12}>
				<Grid item xs={3}>
					<h3>Phases:</h3>
				</Grid>
				<Grid item xs={3}>
					{mergeBtn}
				</Grid>
			</Grid>
			{phases}
			</div>
		);
	}
}

export default ProjectForm;